/**
 * Lightweight GA4 event helper.
 *
 * gtag is loaded in index.html (measurement id G-KZHTKZ5TCD) behind Google
 * Consent Mode v2. Calls here are safe no-ops when gtag is unavailable (e.g.
 * blocked by an ad-blocker or not yet loaded). Under denied consent GA4 still
 * records cookieless, modeled events, so funnel events are captured either way.
 *
 * Analytics must NEVER break the app — every call is wrapped in try/catch.
 *
 * NOTE: lives at src/analytics.ts (not src/lib/) because `lib/` is gitignored.
 */
type EventParams = Record<string, string | number | boolean | undefined>

export function trackEvent(name: string, params: EventParams = {}): void {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params)
    }
  } catch {
    // swallow — instrumentation failures should never surface to users
  }
}
